import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserActivation } from 'src/app/models/userActivation';
import { ManagementService } from 'src/app/services/management.service';
import { environment } from "src/environments/environment";
@Component({
    selector: 'app-activation',
    templateUrl: './activation.component.html',
    styleUrls: ['./activation.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ActivationComponent implements OnInit {
    
    public setBackgroundActive = false;

    public environment = environment;

    constructor(
        public router: Router,
        public projectTitle: Title,
        public managementService: ManagementService,
        private route: ActivatedRoute,
        public window: Window
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams
            .subscribe(params => {
                    const userActivation: UserActivation = {id: params.id};
                    this.managementService.activateUser(userActivation).subscribe((result) => {
                    });
                }
            );
        if (this.projectTitle.getTitle().toLowerCase().includes('SGS Precision Gateway'.toLocaleLowerCase())) {
            this.setBackgroundActive = true;
        } else {
            this.setBackgroundActive = false;
        }
    }

}

